export default [{
    title: 'Registro de Atividades',
    name: 'activity-records',
    path: '/activity-records/:per_page/:page',
    component: () => import( /* webpackChunkName: "activityRecords" */ './ActivityRecords')
}]